import React, { type FunctionComponent } from 'react';
import { Inline, Text } from '@atlaskit/primitives/compiled';

const AKLabel = React.lazy(() =>
	import(
		/* webpackChunkName: '@atlaskit-internal_.form' */
		'@atlaskit/form'
	).then((module) => ({
		default: module.Label,
	})),
);

interface Props {
	isRequired?: boolean;
	label: string;
	name: string;
}

export const Label: FunctionComponent<Props> = ({ isRequired, label, name }) => {
	return (
		<AKLabel htmlFor={name} id={`${name}-label`}>
			<Inline space="space.025">
				{label}
				{isRequired && (
					// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
					<Text as="strong" color="color.text.danger" size="small">
						*
					</Text>
				)}
			</Inline>
		</AKLabel>
	);
};
